import styled, { css } from 'styled-components';

export const JSONWrapper = styled('div')<{ disabled?: boolean; blockAll?: boolean }>`
  width: 100%;
  ${({ disabled, blockAll }) =>
    disabled &&
    (blockAll
      ? css`
          pointer-events: none;
          opacity: 0.6;
        `
      : css`
          div[class^='styles-module_insertBanner'] {
            display: none;
          }
          div[class^='styles-module_rightContainer'] {
            display: none;
          }
          div[class^='styles-module_clickNode']:has(> div[class^='styles-module_valueData']) {
            pointer-events: none;
          }
        `)}
`;
